import React from 'react';

import { SVGPropsType } from 'src/types';
const IDVerification = (props: SVGPropsType) => {
    const { onClick, style, className } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="65px"
            height="64px"
            fill="none"
            viewBox="0 0 65 64"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                fill="#A2A2A2"
                d="M8.5 10.667h48c2.933 0 5.333 2.4 5.333 5.333v32c0 2.933-2.4 5.333-5.333 5.333h-48c-2.933 0-5.333-2.4-5.333-5.333V16c0-2.933 2.4-5.333 5.333-5.333z"
            />
            <path
                stroke="#494949"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M22.133 22.4H12M22.133 32H12M22.133 41.6H12"
            />
            <circle cx="40.432" cy="32" r="13" fill="#494949" />
            <path
                stroke="#DFF60D"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M53.068 22.8L41.153 34.715l-5.073-5.073"
            />
        </svg>
    );
};
export default IDVerification;
